<template lang="pug">
.cp-joinus
  h1 加入我们
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
</style>
